
import React, { useEffect, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import { useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

// Rutas donde el sidebar debe mostrarse
const SIDEBAR_ROUTES = [
  '/admin',
  '/admin/moderacion',
  '/admin/revision',
  '/admin/modificar-pregunta',
  '/user/profile',
  '/user/mis-preguntas',
  '/user/premios',
];

export default function SidebarTransition({ activeTab, setActiveTab, userRole, onSidebarVisible }) {
  const location = useLocation();
  const { user } = useUser();
  const shouldShow = user && SIDEBAR_ROUTES.some(route => location.pathname.startsWith(route));
  const [visible, setVisible] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (shouldShow) {
      // Esperar un tick para activar la animación
      setTimeout(() => setVisible(true), 10);
    } else {
      setVisible(false);
    }
    if (!shouldShow) {
      setMobileOpen(false);
    }
    // eslint-disable-next-line
  }, [shouldShow]);

  useEffect(() => {
    const reportVisibility = () => {
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const sidebarIsVisible = !!shouldShow && (isDesktop || mobileOpen);
      if (onSidebarVisible) onSidebarVisible(sidebarIsVisible);
    };

    reportVisibility();
    window.addEventListener('resize', reportVisibility);
    return () => window.removeEventListener('resize', reportVisibility);
  }, [shouldShow, mobileOpen, onSidebarVisible]);

  const closeMobileSidebar = () => setMobileOpen(false);

  return (
    <>
      {shouldShow && (
        <button
          type="button"
          onClick={() => setMobileOpen(prev => !prev)}
          className="lg:hidden fixed left-3 top-[4.5rem] z-40 inline-flex items-center justify-center w-10 h-10 rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 shadow-lg text-gray-800 dark:text-gray-200"
          aria-label={mobileOpen ? 'Ocultar menu lateral' : 'Mostrar menu lateral'}
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {mobileOpen ? (
              <path d="M15 18l-6-6 6-6" />
            ) : (
              <path d="M9 18l6-6-6-6" />
            )}
          </svg>
        </button>
      )}

      {shouldShow && mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/40 z-20"
          onClick={closeMobileSidebar}
          aria-hidden="true"
        />
      )}

      <aside
        className={`
          fixed left-0 top-0 h-screen w-[68vw] max-w-64 lg:w-56 z-30
          bg-white dark:bg-gray-900 shadow-lg border-r border-gray-200 dark:border-gray-800
          transition-transform duration-300
          ${visible ? 'lg:translate-x-0' : ''}
          ${mobileOpen && shouldShow ? 'translate-x-0' : '-translate-x-full'}
        `}
        aria-hidden={!visible}
      >
        <AdminSidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          userRole={userRole}
          onNavigate={closeMobileSidebar}
        />
      </aside>
    </>
  );
}
